import { ModesOfTransportation } from "models/filters/ModesOfTransportation";
import { LogisticServiceProviderList } from "models/filters/LogisticServiceProviderList";
import { PackagingTypeList } from "models/filters/PackagingTypeList";
import { ProductsList } from "models/filters/ProductsList";
import { config } from "api/apiRoutes";
import { FiltersRequestParameters } from "api/lokiRequestModels/FiltersRequestParameters";
import { lokiAxios } from "api/serviceConfig";

export class FiltersService {
    // 1
    async getModesOfTransportation(data: FiltersRequestParameters) {
        return await lokiAxios.get<ModesOfTransportation>(
            config.modesOfTransportationUrl,
            {
                params: {
                    startTime: data.startTime,
                    endTime: data.endTime,
                    customerId: data.customerId,
                },
            }
        );
    }

    // 2
    async getLogisticsServiceProviders(data: FiltersRequestParameters) {
        return await lokiAxios.get<LogisticServiceProviderList>(
            config.logisticServiceProvidersUrl,
            {
                params: {
                    startTime: data.startTime,
                    endTime: data.endTime,
                    customerId: data.customerId,
                },
            }
        );
    }

    // 3
    async getPackagingTypes(data: FiltersRequestParameters) {
        return await lokiAxios.get<PackagingTypeList>(
            config.packagingTypesUrl,
            {
                params: {
                    startTime: data.startTime,
                    endTime: data.endTime,
                    customerId: data.customerId,
                },
            }
        );
    }

    // 4
    async getProductTypes(data: FiltersRequestParameters) {
        return await lokiAxios.get<ProductsList>(config.productsUrl, {
            params: {
                startTime: data.startTime,
                endTime: data.endTime,
                customerId: data.customerId,
            },
        });
    }
}
